import { render, staticRenderFns } from "./AvanzaContenitoreSF.vue?vue&type=template&id=07df54b6&"
import script from "./AvanzaContenitoreSF.vue?vue&type=script&lang=js&"
export * from "./AvanzaContenitoreSF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports